// Static color map - no AI needed for fixed color list
const COLOR_MAP: Record<string, string> = {
  // Gold variants
  "gold 14k": "#D4AF37",
  "yellow gold 14k": "#D4AF37",
  "gold": "#D4AF37",
  "yellow gold": "#D4AF37",
  "antique gold": "#C9A227",
  "champagne gold": "#F7E7CE",
  "matte gold": "#CDA434",
  
  // Rose/Pink Gold
  "rose gold 14k": "#c38e5e",
  "rose gold": "#c38e5e",
  "pink gold 14k": "#E8B4B8",
  "pink gold": "#E8B4B8",
  
  // White Gold
  "white gold 14k": "#E8E8E8",
  "white gold": "#E8E8E8",
  
  // Silver variants
  "silver": "#C0C0C0",
  "sterling silver": "#C4CACE",
  
  // Other metals
  "platinum": "#E5E4E2",
  "gunmetal": "#2C3539",
  "bronze": "#CD7F32",
  "copper": "#B87333",
  
  // Basic colors
  "black": "#000000",
  "white": "#FFFFFF",
  
  // Reds & Pinks
  "red": "#DC2626",
  "burgundy": "#800020",
  "coral": "#FF7F50",
  "pink": "#EC4899",
  
  // Blues
  "blue": "#2563EB",
  "light blue": "#7DD3FC",
  "navy blue": "#1E3A5F",
  "navy": "#1E3A5F",
  "turquoise": "#40E0D0",
  
  // Greens
  "green": "#16A34A",
  "emerald": "#50C878",
  
  // Other colors
  "purple": "#9333EA",
  "pearl": "#F5F5F0",
  "ivory": "#FFFFF0",
  
  // Hebrew variants
  "זהב": "#D4AF37",
  "זהב צהוב": "#D4AF37",
  "זהב לבן": "#E8E8E8",
  "זהב רוז": "#c38e5e",
  "רוז גולד": "#c38e5e",
  "כסף": "#C0C0C0",
  "פלטינה": "#E5E4E2",
  "אדום": "#DC2626",
  "כחול": "#2563EB",
  "תכלת": "#7DD3FC",
  "בורדו": "#800020",
  "ירוק": "#16A34A",
  "סגול": "#9333EA",
  "טורקיז": "#40E0D0",
  "ורוד": "#EC4899",
  "שנהב": "#FFFFF0",
  "פנינה": "#F5F5F0",
};

// Default fallback color
const DEFAULT_COLOR = "#D4AF37";

export function getColorHex(colorName: string): Promise<string> {
  const normalized = colorName.trim().toLowerCase();
  const hex = COLOR_MAP[normalized] || DEFAULT_COLOR;
  return Promise.resolve(hex);
}

export function getColorHexSync(colorName: string): string {
  const normalized = colorName.trim().toLowerCase();
  return COLOR_MAP[normalized] || DEFAULT_COLOR;
}

export function preloadColors(_colorNames: string[]): void {
  // No-op - colors are already available synchronously
}
